import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';

/**
 * @class
 *
 * PhotoPack page.
 */
const SafetyAuditPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        errorMessage: '',
        opp: {},
        attachedFiles:[],
        isWorkOrder: false,

        SafetyAudit: {},
        SafetyAuditError: false,
    }

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);
        await this.getDocs();
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getDocs = async() =>{
        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(returnedFiles => {
             if(returnedFiles.length !== 0){
                this.setState({attachedFiles: returnedFiles})
            }
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });
    }

    sanitizeFileName = (input) => {
        if (!input) return "file";

        const dot = input.lastIndexOf(".");
        const baseRaw = dot > 0 ? input.slice(0, dot) : input;
        const ext = dot > 0 ? input.slice(dot).toLowerCase() : "";

        let base = baseRaw.normalize("NFKD").replace(/\p{Diacritic}/gu, "");
        base = base.replace(/\s+/g, "-");
        base = base.replace(/[^a-zA-Z0-9._-]/g, "");
        base = base.replace(/[._-]{2,}/g, "-");
        base = base.replace(/^[-._]+|[-._]+$/g, "");
        base = base.toLowerCase();
        if (!base) base = "file";
        const MAX_BASE_LEN = 200;
        if (base.length > MAX_BASE_LEN) base = base.slice(0, MAX_BASE_LEN);

        return base + ext;
    };

    capturePhoto = async(files, stateNameError) => {
        if (!files || files.length === 0) return;
        for (const file of files) {
            const stateName = this.sanitizeFileName(file.name);
            try {
                await uploadSinglePhoto({
                    file,
                    stateName,
                    stateNameError,
                    username: this.username,
                    opportunityId: this.opportunityId,
                    type: this.type,
                    setState: this.setState.bind(this),
                    source: this.source,
                });
            } catch (err) {
                console.log('Upload failed for', stateName, err);
            }
        }

        await this.getDocs();
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>Site Safety Audit Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>
                
                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        <table>
                            <tbody>

                                {/* All Photos*/}
                                <tr>
                                    <td className="w-50">
                                        {
                                            this.state.SafetyAuditError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Photos: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> All Photos</div>
                                        }
                                    </td>
                                    <td className="w-50">
                                        <label htmlFor="SafetyAuditUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label>
                                        <input className={css.PhotoPack__PicInput} id="SafetyAuditUpload" type="file" accept="image/*" disabled={this.state.uploading} multiple onChange={(event) => this.capturePhoto(event.target.files, 'SafetyAuditError')}/>
                                    </td>
                                </tr>
                                {this.state.attachedFiles &&
                                    Object.entries(this.state.attachedFiles).map(([name, url]) => (
                                    <tr key={name}>
                                        <td className="w-50">
                                            <button className="btn btn-outline text-green" onClick={() => this.previewImage(url)}>
                                                <FontAwesomeIcon icon={faCircle} /> {name}
                                            </button>
                                        </td>
                                        <td className="w-50">
                                            <button className="btn btn-primary" onClick={() => this.previewImage(url)}>
                                                View Pic
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(SafetyAuditPhotoPack);